import { render, staticRenderFns } from "./files-upload-list.vue?vue&type=template&id=1b88ad3d&scoped=true"
import script from "./files-upload-list.vue?vue&type=script&lang=js"
export * from "./files-upload-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b88ad3d",
  null
  
)

export default component.exports